import { uniqueContext } from "@tastyworks/ui-library"
import { writable, type Writable } from "svelte/store"
import type { NavController } from "./controller/navigation.svelte"

type GroupContext = {
  disclaimer?: string
}
const groupContext = uniqueContext<GroupContext>()
export const getGroupContext = groupContext.getContext
export const setGroupContext = groupContext.setContext

type WizardContext = {
  step: Writable<number>
  back: () => void
  next: () => void
  goto: (step: number) => void
}

function createWizardContext() {
  const { setContext, getContext } = uniqueContext<WizardContext>()

  return {
    getContext,
    setContext: (numSteps: number) => {
      const step = writable(0)

      return setContext({
        step,
        next: () => {
          step.update(($step) => {
            if ($step + 1 >= numSteps) {
              return $step
            }

            return $step + 1
          })
        },
        back: () => {
          step.update(($step) => {
            if ($step - 1 < 0) {
              return $step
            }
            return $step - 1
          })
        },
        goto: (n: number) => {
          step.set(n)
        },
      })
    },
  }
}

const context = createWizardContext()
export const setWizardContext = context.setContext
export const getWizardContext = context.getContext

const navContext = uniqueContext<NavController>()
export const getNavContext = navContext.getContext
export const setNavContext = navContext.setContext
